var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-list',{attrs:{"data":_vm.data || _vm.list,"columns":_vm.columns,"isShowHeader":_vm.isShowHeader,"table-style":{name:'mixture'}}})
}
var staticRenderFns = []

export { render, staticRenderFns }